import type { AuthStatus } from '@graphit/types'
import { createAuthClient } from 'better-auth/client'

import env from '../environments'

export const authClient = createAuthClient({
	baseURL: env.apiUrl
})

function toApiError(error: { status: number; statusText: string; message?: string | undefined }) {
	const apiError = new Error(error.message ?? error.statusText) as Error & { response: { status: number } }

	apiError.response = { status: error.status }

	return apiError
}

export async function login(email: string, password: string) {
	const { error } = await authClient.signIn.email({ email, password })

	if (error) {
		throw toApiError(error)
	}
}

export async function signup(name: string, email: string, password: string) {
	const { error } = await authClient.signUp.email({ name, email, password })

	if (error) {
		throw toApiError(error)
	}
}

export async function loginWithGoogle() {
	const { error } = await authClient.signIn.social({
		provider: 'google',
		callbackURL: window.location.origin
	})

	if (error) {
		throw toApiError(error)
	}
}

export async function logout() {
	await authClient.signOut()
}

export async function getUserStatus(): Promise<AuthStatus> {
	const { data, error } = await authClient.getSession()

	if (error) {
		throw toApiError(error)
	}

	return { authenticated: data !== null }
}

export async function resetPasswordEmail(email: string) {
	const { error } = await authClient.requestPasswordReset({
		email,
		redirectTo: `${window.location.origin}/auth/reset-password`
	})

	if (error) {
		throw toApiError(error)
	}
}

export async function resetPassword(token: string, password: string) {
	const { error } = await authClient.resetPassword({ newPassword: password, token })

	if (error) {
		throw toApiError(error)
	}
}

export async function changePassword(currentPassword: string, newPassword: string) {
	const { error } = await authClient.changePassword({ currentPassword, newPassword })

	if (error) {
		throw toApiError(error)
	}
}
